// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.summary-info__data-row div,\n.summary-info__data-row p {\n  font-weight: bold;\n  line-height: inherit;\n}\n.summary-info__data-title {\n  width: 150px;\n  min-width: 150px;\n  font-weight: normal;\n  word-break: normal;\n}\n.summary-info__data-title:empty ~ div {\n  color: #b68e56;\n}\n", ""]);
// Exports
module.exports = exports;
